import { ssrApi } from 'api/ssr';
import { BlogPostPage } from 'components/template/blog-post';
import { IBlogPost } from 'constants/types';
import { ParsedUrlQuery } from 'querystring';
import { IComment } from 'constants/types';
import { isValidEntity, notFoundResult } from 'utils/ssr-not-found';

export default function BlogPost({
  post,
  comments,
}: {
  post: IBlogPost;
  comments: IComment[];
}) {
  return <BlogPostPage post={post} comments={comments} />;
}

export async function getServerSideProps({ query }: { query: ParsedUrlQuery }) {
  const { id } = query;
  const post = await ssrApi.blog.getById(id?.toString());

  if (!isValidEntity(post)) {
    return notFoundResult();
  }

  const { results: comments } = await ssrApi.publications.getByPublicationId(
    id?.toString()
  );

  return {
    props: { post, comments: comments ?? [] },
  };
}
